import _ from 'lodash'
import store from './store'
import { isObjectNotEmpty } from './tools'
import { updateMenuPosition } from '../apis/backend'

export const getFirstProductCategory = product => {
  const { categories } = product;
  let firstCategory = null;
  const shopCategories = store.getState().firebaseRealTime.menu?.categories;

  if (categories) {
    const productCategories = categories.split(',');
    const categoryKey = productCategories[0].split('@')[0];
    firstCategory = shopCategories?.[categoryKey];
  }
  return firstCategory;
}

export const sortItemsPositionForShop = async (event, items, itemKey, isCatgory, isProduct, shopId) => {
  const { active = {}, over = {} } = event;
  const positionUpdates = {};
  const oldIndex = _.findIndex(_.keys(items), elt => elt === active.id);
  const newIndex = _.findIndex(_.keys(items), elt => elt === over.id);

  Object.keys(items).slice(
    oldIndex > newIndex ? newIndex : oldIndex,
    (oldIndex > newIndex ? oldIndex : newIndex) + 1
  ).forEach(key => {
    const item = items[key];
    const { position: initialPos } = item;
    if (initialPos === oldIndex) item.position = newIndex;
    else if (oldIndex < initialPos && initialPos <= newIndex && oldIndex < newIndex)
      item.position = initialPos - 1;
    else if (newIndex <= initialPos && initialPos < oldIndex && oldIndex > newIndex)
      item.position = initialPos + 1;

    if (initialPos !== item.position) {
      positionUpdates[key] = { position: item.position }
    }
  })

  if (isObjectNotEmpty(positionUpdates)) {
    const positions = isCatgory ? { categories: { [itemKey]: { items: positionUpdates } } } : isProduct ? { sections: { [itemKey]: { products: positionUpdates } } } : { sections: positionUpdates }
    if (!shopId) return;
    await updateMenuPosition(positions, shopId)

  }

}

export const returnCategories = (categories = {}, allCategories) => {
  let categoriesToArray = [];
  const returnArray = [];
  if (typeof categories === 'string') {
    categoriesToArray = categories.includes(',') ? categories.split(',') : [categories];
    _.forEach(categoriesToArray, categoryKey => {
      if (allCategories && allCategories[categoryKey]) {
        const { name = '', type = null } = allCategories[categoryKey];
        returnArray.push({
          name,
          key: categoryKey,
          type
        });
      }
    });
  }

  return returnArray;
}
export const getOriginalCategories = (items, ref, allCategories, isIngType) => {
  let originalCategories = [];
  _.entries(items).forEach(([itemKey, item]) => {
    const { products = {}, items } = item;
    const itemsToCheck = isIngType ? items : products;

    const originalItem = _.values(itemsToCheck).filter(item => item.ref === ref);
    if (originalItem?.length > 0) {
      const categoriesToCheck = isIngType ? originalItem[0]?.subcategories : originalItem[0]?.categories;
      originalCategories = returnCategories(categoriesToCheck, allCategories);
    }

  });

  return originalCategories;
};
export const getCopyName = (key, name) =>
  key?.includes('copy') ? `${name} (copie)` : name;

export const setCopyKey = (key) => `${key}copy`;
export const getProductDetailsFromConfig = (menus, configProducts, shopId, isUpdate) => {
  if (!menus || !configProducts?.length) return [];

  if (isUpdate) {
    return configProducts.reduce((acc, configProduct) => {
      const section = menus[shopId]?.sections?.[configProduct.productSectionKey];
      const product = section?.products?.[configProduct.productKey];
      if (!product) return acc;

      acc.push({
        productKey: configProduct.productKey,
        productName: product.name,
        productSectionKey: configProduct.productSectionKey,
      });
      return acc;
    }, []);
  }

  const sectionsMap = configProducts.reduce((acc, configProduct) => {
    const section = menus[shopId]?.sections?.[configProduct.productSectionKey];
    const product = section?.products?.[configProduct.productKey];
    if (!product) return acc;

    const sectionId = configProduct.productSectionKey;

    if (!acc[sectionId]) {
      acc[sectionId] = {
        id: sectionId,
        name: section?.name || `Section ${sectionId}`,
        products: []
      };
    }

    acc[sectionId].products.push({
      key: configProduct.productKey,
      name: product.name,
      price: product.price
    });

    return acc;
  }, {});

  return Object.values(sectionsMap);
};

export const getOffersFromConfig = (menus, configProducts, shopId) => {
  if (!menus || !configProducts?.length) return [];

  return configProducts
    .filter(configProduct => configProduct.productOfferedKey)
    .map(configProduct => {
      const mainProductSection = menus[shopId]?.sections?.[configProduct.productSectionKey];
      const mainProduct = mainProductSection?.products?.[configProduct.productKey];
      const offeredProductSection = menus[shopId]?.sections?.[configProduct.productOfferedSectionKey];
      const offeredProduct = offeredProductSection?.products?.[configProduct.productOfferedKey];

      return {
        id: `${configProduct.productKey}-${configProduct.productOfferedKey}`,
        productKey: configProduct.productKey,
        productName: mainProduct?.name || `Produit ${configProduct.productKey}`,
        productSectionKey: configProduct.productSectionKey,
        productSectionName: mainProductSection?.name || `Section ${configProduct.productSectionKey}`,

        productOfferedKey: configProduct.productOfferedKey,
        productOfferedName: offeredProduct?.name || `Produit ${configProduct.productOfferedKey}`,
        productOfferedSectionKey: configProduct.productOfferedSectionKey,
        productOfferedSectionName: offeredProductSection?.name || `Section ${configProduct.productOfferedSectionKey}`,


      };
    })
    .filter(offer => offer.productName && offer.productOfferedName);
};